module.exports = __webpack_public_path__ + "img/DummyBackground.02b65d49.png";